import { HStack, Stack, Text, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

import { TextWithSubtextSkeleton } from '../../../../../AssetsLoading';
import { FixedIncomeSharedInfoTypes, FixedIncomeSharedInfoTypesLoading } from '../types';

export const ProfitabilityInfo: React.FC<FixedIncomeSharedInfoTypes> = ({
  selectedFee,
  offer,
  w,
}) => {
  const yearly = selectedFee?.profitabilityYearly || offer.profitabilityYearly;
  const toMaturity = selectedFee?.profitabilityToMaturity || offer.profitabilityToMaturity;

  return (
    <Stack w={w}>
      <VStack space="stack.quarck" justifyContent="space-between">
        <Text variant="semibold">Rentabilidade</Text>
        <HStack space="inline.quarck" alignItems="flex-end">
          <Text>{Utils.Mask.Percentage(yearly)}</Text>
          <Text color="neutral.dark" fontSize="xs">
            Anual
          </Text>
        </HStack>
        <Text color="neutral.dark" fontSize="xs">
          {Utils.Mask.Percentage(toMaturity)} - Até o venc.
        </Text>
      </VStack>
    </Stack>
  );
};

export const ProfitabilityInfoLoading: React.FC<FixedIncomeSharedInfoTypesLoading> = ({ w }) => {
  return (
    <Stack w={w}>
      <VStack space="stack.quarck" justifyContent="space-between">
        <Text variant="semibold">Rentabilidade</Text>
        <TextWithSubtextSkeleton />
      </VStack>
    </Stack>
  );
};
